import React from "react";
import ShowUserAudit from "./ShowUserAudit";
import { Box, Grid } from "@material-ui/core";
import momentJalai from "moment-jalaali";
import ShowLegalAudit from "./ShowLegalAudit";

class ShowAuditRow extends React.Component {
  constructor(props) {
    super(props);
    this.filter = [
      "recieverable_type",
      "chequeable_type",
      "guarantor_id",
      "chequeable_id",
    ];
  }

  showBool(d) {
    switch (d.toString()) {
      case "0":
        return "غیرفعال";
      case "1":
        return "فعال";
      default:
        return d;
    }
  }

  checkStatus(c) {
    switch (c) {
      case "bounced":
        return "برگشتی";
      case "returned-settlement":
        return "عودتی - تسویه";
      case "returned-unresolved":
        return "عودتی - بلاتکلیف";
      case "cashed":
        return "پاس شده";
      case "current":
        return "جاری";
      default:
        return c;
    }
  }

  getFieldName(n) {
    switch (n) {
      case "bank":
        return "نام بانک";
      case "bank_branch":
        return "نام شعبه";
      case "due_date":
        return "تاریخ سررسید";
      case "cheque_id":
        return "شماره چک";
      case "icis":
        return "شماره صیاد";
      case "amount":
        return "مبلغ چک";
      case "account":
        return "حساب";
      case "first_party_id":
        return "صاحب چک";
      case "second_party_id":
        return "در وجه";
      case "giver_user_id":
        return "دهنده چک";
      case "is_guarantee_cheque":
        return "چک تضمینی";
      case "guarantor_id":
        return "ضامن";
      case "recommender_id":
        return "معرف";
      case "delivered_date":
        return "تاریخ تحویل";
      case "transfered_date":
        return "تاریخ واگذاری";
      case "bounced_date":
        return "تاریخ برگشت خوردن";
      case "cashed_date":
        return "تاریخ پاس شدن";
      case "returned_date":
        return "تاریخ عودت";
      case "status":
        return "وضعیت چک";
      case "description":
        return "توضیحات";
      case "updated_at":
        return "تاریخ ویرایش";
      case "created_at":
        return "تاریخ ثبت";
      case "chequeable_type":
        return "نوع چک";
      case "chequeable_id":
        return "شماره نوع چک";
      case "recieverable_type":
        return "نوع گیرنده";
      case "recieverable_id":
        return "گیرنده";
      default:
        return n;
    }
  }

  getrecieverableType(c) {
    switch (c) {
      case "user":
        return "حقیقی";
      case "legal_entity":
        return "حقوقی";
      case "bank":
        return "بانک";
      default:
        return c;
    }
  }

  render() {
    const { cheque, field, value, old, rowDataOld, rowDataNew } = this.props;

    if (this.filter.includes(field)) return <div></div>;

    let oldData;
    let newData;
    switch (field) {
      case "giver_user_id":
      case "first_party_id":
      case "second_party_id":
      case "recommender_id":
        oldData = <ShowUserAudit userId={value} />;
        newData = <ShowUserAudit userId={old} />;
        break;
      case "status":
        oldData = this.checkStatus(value);
        newData = this.checkStatus(old);

        break;
      case "due_date":
      case "transfered_date":
      case "returned_date":
      case "delivered_date":
      case "cashed_date":
      case "bounced_date":
        oldData = momentJalai(value).format("jYYYY/jM/jD");
        newData = momentJalai(old).format("jYYYY/jM/jD");

        if (oldData === "Invalid date") oldData = "-";

        if (newData === "Invalid date") newData = "-";
        break;
      case "recieverable_type":
        oldData = this.getrecieverableType(value);
        newData = this.getrecieverableType(old);
        break;
      case "recieverable_id":
        if (rowDataOld["recieverable_type"] == null)
          rowDataOld["recieverable_type"] = cheque?.recieverable_type;

        if (rowDataNew["recieverable_type"] == null)
          rowDataNew["recieverable_type"] = cheque?.recieverable_type;

        if (rowDataOld["recieverable_type"] === "user")
          oldData = <ShowUserAudit userId={value} />;
        else if (rowDataOld["recieverable_type"] === "legal_entity")
          oldData = <ShowLegalAudit legalId={value} />;
        else oldData = value;

        if (rowDataNew["recieverable_type"] === "user")
          newData = <ShowUserAudit userId={old} />;
        else if (rowDataNew["recieverable_type"] === "legal_entity")
          newData = <ShowLegalAudit legalId={old} />;
        else newData = old;
        break;

      case "is_guarantee_cheque":
        oldData = this.showBool(value);
        newData = this.showBool(old);

        break;

      default:
        oldData = value;
        newData = old;
        break;
    }

    return (
      <Grid item md={6}>
        <Box style={{ marginLeft: 10 }}>
          <table style={{ width: "100%", border: "1px solid white" }}>
            <tbody>
              <tr>
                <td style={{ width: "30%", textAlign: "right", border: "none" }}>
                  {this.getFieldName(field)}
                </td>
                <td style={{ width: "30%", textAlign: "right", border: "none" }}>
                  {oldData}
                </td>
                <td style={{ width: "40%", textAlign: "right", border: "none" }}>
                  {newData}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      </Grid>
    );
  }
}

export default ShowAuditRow;
